<section class="section-wrapper">
  <h2 class="cam-heading">{{content?.['b2b.managetraveler.addnewtraveler']}}</h2>

  <div class="section-context">
    <div class="menu-left-content">
      <app-menu-nav-listing></app-menu-nav-listing>
    </div>
    <div class="right-content"> </div>
  </div>
</section>
